export default class Basket {

    constructor() {
        this.registerElements()
        this.bindEvents()
        if (this.basket.length > 0) {
            this.fillBasketButton();
        }
    }

    /**
     * Register DOM elements
     */
    registerElements() {
        this.bg_overlay = $("#basket-overlay");
        this.basket_button = $('#basket-btn');
        this.basket_empty = this.basket_button.find('.basket-empty');
        this.basket_full = this.basket_button.find('.basket-full');
        this.basket_subtotal = this.basket_button.find('#basket-subtotal');
        this.basket_quantity = this.basket_button.find('#basket-quantity');
        this.basket = $('#basket-preview');
        this.basket_cart = this.basket.find('.basket-cart');
        this.total_items = 0;
        this.product = $('.product-page');
        this.product_id = this.product.find('#variant-id');
        this.choose_size = this.product.find('#choose-size');
        this.t = false;
    }

    /**
     * Binds events to DOM elements
     */
    bindEvents() {
        this.basket_button.on('click', function (e) {
            e.preventDefault();
            this.showBasket();
            if (this.basket_cart.html() == "") {
                this.fillBasket();
            }
        }.bind(this));

        $(document).on("click", '.close-basket', function (e) {
            this.hideBasket();
        }.bind(this));

        $(document).on("click", '.add-to-basket', function (event) {
            event.preventDefault();
            this.choose_size.removeClass('do-choose')
            if (this.product_id.val() == 0) {
                this.choose_size.addClass('do-choose')
                this.choose_size.focus();
            }
            else {
                this.addToCart(this.product_id.val(), 1);
            }
        }.bind(this));

        $('.btn-plus').on("click", function (event) {
            let self = $(event.target);
            let $nav = self.closest('.buy-nav');
            let $amount_field = $nav.find('.amount');
            let amount = $amount_field.val();
            amount++;
            $amount_field.val(amount);
            this.submitForCheckout($amount_field);
        }.bind(this));

        $('.btn-min').on("click", function (event) {
            let self = $(event.target);
            let $nav = self.closest('.buy-nav');
            let $amount_field = $nav.find('.amount');
            let amount = $amount_field.val();
            amount--;
            if (amount < 0) {
                amount = 0;
            }
            $amount_field.val(amount);
            this.submitForCheckout($amount_field);
        }.bind(this));

        $('.remove-item').on("click", function (event) {
            let self = $(event.target);
            let id = self.data('id');
            $('#input' + id).val(0);
            this.addToCart(id, 0);
        }.bind(this));

        $('.amount').on("keyup", function (event) {
            let self = $(event.target);
            let $nav = self.closest('.buy-nav');
            let id = $nav.data('id');
            let amount = self.val();
            this.addToCart(id, amount);
        }.bind(this));

        $(document).keydown(function (e) {
            e.stopPropagation();
            if (e.keyCode == 27) {
                this.hideBasket();
            }
        }.bind(this));
    }

    submitForCheckout($amount_field) {
        clearTimeout(this.t);
        // if($('.webshop-order').length > 0) {
        this.t = setTimeout(function () {
            $amount_field.trigger('keyup');
        }, 500);
        //}
    }

    /**
     * Show basket
     */
    showBasket() {
        this.basket.removeClass('closed').addClass('open').slideDown(400);
        this.bg_overlay.stop().fadeIn();
    }

    /**
     * Hide basket
     */
    hideBasket() {
        this.basket.addClass('closed').removeClass('open');
        this.basket.stop().fadeOut(150);
        this.bg_overlay.stop().fadeOut();
    }

    /**
     * Fill basket
     */
    fillBasket() {
        this.basket_cart.load('/cart/basket/', function () {
            this.basket.slideDown();
        }.bind(this));
    }

    /**
     * Add product to basket
     */
    addToCart(id, amount) {
        $.get('/cart/add/' + id + '/' + amount +'/', function (data) {
            if (this.basket.length > 0) {
                this.fillBasket();
                this.fillBasketButton();
                this.showBasket();
            }
            else {
                document.location = "/cart";
            }
        }.bind(this));
    }

    /**
     * Set basket button info
     */
    fillBasketButton() {
        $.get('/cart/totals/', function (data) {
            let obj = jQuery.parseJSON(data);
            this.total_items = obj.total_items;
            if (obj.total_items > 0) {
                this.basket_button.removeClass('empty');
                this.basket_empty.hide();
                this.basket_full.fadeIn();
                this.basket_quantity.html("("+obj.total_items+")");
                //this.basket_subtotal.html(obj.sign + " " + obj.subtotal);
            }
            else {
                this.basket_button.addClass('empty');
                this.basket_empty.fadeIn();
                this.basket_full.hide();
            }
        }.bind(this));
    }

    //
    // setDeliverCountry(country) {
    //     $.post('/cart/set-deliver-country', {country: country}, function (data) {
    //         if ($basket.length > 0) {
    //             this.fillBasket();
    //         }
    //         else {
    //             this.checkout.fillTotals();
    //         }
    //     });
    // }
}

